import { ApolloError, useQuery, useSubscription } from "@apollo/client";
import {
  MY_TIMESHEET_GET_REQUESTS_BADGE,
  MY_TIMESHEET_TIMESHEETS_SUBSCRIPTION,
} from "my-timesheet/graphql";

export interface UseMyTimesheetRequestsBadgeParams {
  startDate: string;
  endDate: string;
}

export interface UseMyTimesheetRequestsBadgeResult {
  data: number;
  loading: boolean;
  error?: ApolloError;
}

interface BadgeQueryData {
  getMyTimesheetRequestsBadge: number;
}

interface BadgeQueryVars {
  startDate: string;
  endDate: string;
}

export const useMyTimesheetRequestsBadge = ({
  startDate,
  endDate,
}: UseMyTimesheetRequestsBadgeParams): UseMyTimesheetRequestsBadgeResult => {
  const { data, loading, error, refetch } = useQuery<
    BadgeQueryData,
    BadgeQueryVars
  >(MY_TIMESHEET_GET_REQUESTS_BADGE, {
    fetchPolicy: "cache-and-network",
    variables: { startDate, endDate },
  });

  useSubscription(MY_TIMESHEET_TIMESHEETS_SUBSCRIPTION, {
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.getMyTimesheetRequestsBadge ?? 0,
    loading,
    error,
  };
};

export default useMyTimesheetRequestsBadge;
